
import Hero from "@/components/sections/Hero";
import Work from "@/components/sections/Work";
import SpudBot from "@/components/sections/SpudBot";
import Footer from "@/components/sections/Footer";
import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import TransitionElement from "@/components/sections/TransitionElement";

const Index = () => {
  console.log("[Index] Rendering Index page");
  
  useEffect(() => {
    console.log("[Index] Component mounted");
    return () => console.log("[Index] Component unmounting");
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <SEO 
        title="Seed Potato Organisation" 
        description="The Seed Potato Organisation (SPO) supports and represents the Scottish seed potato industry through research, collaboration, and advocacy. Run by growers for growers."
        keywords={["seed potato", "Scottish agriculture", "potato farming", "seed certification", "potato industry", "agricultural organization"]}
      />
      <article>
        <header>
          <Hero />
          <TransitionElement />
        </header>
        <section aria-label="Latest News and Work">
          <Work />
        </section>
        <section aria-label="AI Assistant">
          <SpudBot />
        </section>
      </article>
      <Footer />
    </main>
  );
};

export default Index;
